import type { SbEditableComponentProps } from "types/storyblok";
import iconSizes, { icons } from "./Icon.config";
import type { IconProps } from "./Icon.d";

const Icon = ({ name, color, size, sbEditable }: SbEditableComponentProps<IconProps>) => {
  const IconComponent = icons[name];

  if (!IconComponent) return null;

  return <IconComponent boxSize={iconSizes[size]} color={color} {...sbEditable} />;
};

export default Icon;
